module.exports = __webpack_public_path__ + "static/img/mould6.1418d79.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/indexEditor/mould/mould6.png
// module id = eNTE
// module chunks = 3